import React from 'react'
import { SelectPicker, Table } from 'rsuite';
import { useState, useEffect } from 'react';
import { EmployeeKRAVM } from '../../Models/ViewModels';
import * as Employee from "../../Services/EmployeeDB";
import { CustomTableHeaderCell } from '../../SharedComponents/CustomTableHeaderCell';
import { CustomTableCell } from '../../SharedComponents/CustomTableCell';
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
export const KRAInfo = (props: any) => {

  const [employeeKRA, setEmployeeKRA] = useState(new Array<EmployeeKRAVM>())
  const getEmployeeKRA = (id: any) => {
    Employee.GetEmployeeKRA(id).then(res => {
      if (res.data) {
        setEmployeeKRA(res.data);
      
      }

    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    getEmployeeKRA(props.id);
  }, [])
  if(employeeKRA.length>0){
  return (
    <div>
      <b>KRA Details :</b>
      <Table
        height={220} 
        data={employeeKRA}
        rowHeight={31}
        headerHeight={30}
        bordered={true}
        cellBordered={true}
        className="border border-dark"
      >
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell> Year</CustomTableHeaderCell>
          <CustomTableCell dataKey="ReviewYear" />
        </Column>
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell>Month</CustomTableHeaderCell>
          <CustomTableCell dataKey="ReviewMonth" />
        </Column>
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell>KRA 1</CustomTableHeaderCell>
          <CustomTableCell dataKey="KRA1" />
        </Column>
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell>KRA 2</CustomTableHeaderCell>
          <CustomTableCell dataKey="KRA2" />
        </Column>
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell>KRA 3</CustomTableHeaderCell>
          <CustomTableCell dataKey="KRA3" />
        </Column>
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell>KRA 4</CustomTableHeaderCell>
          <CustomTableCell dataKey="KRA4" />
        </Column>
        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell>KRA 5</CustomTableHeaderCell>
          <CustomTableCell dataKey="KRA5" />
        </Column>
        <Column align="center" flexGrow={1} fixed>
          <CustomTableHeaderCell>Total Score</CustomTableHeaderCell>
          <CustomTableCell dataKey="KRATotalScore" />
        </Column>
      </Table>
    </div>
  )}
  else{
    return<></>
  }
}